import { Divider } from '../../../ui/Divider/Divider';
import { CustomObligationBanner } from '../ObligationBanners/CustomObligationBanner';
import { LegalBasisProps } from './LegalBasis.types';

export function LegalBasis({ componentInfo }: LegalBasisProps) {
  if (!componentInfo.obligations) return null;

  return (
    <div className="flex flex-col border border-gray-100 rounded-lg p-4">
      <h2 className="text-base font-medium text-left text-gray-900v2">
        {componentInfo.title}
      </h2>
      <Divider classes="my-[14px]" />
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2 items-start">
          <span className="text-xs text-gray-550 font-medium uppercase leading-5 tracking-wide">
            Obligations:
          </span>
        </div>
        {componentInfo.obligations.map((obligation) => (
          <CustomObligationBanner obligation={obligation} />
        ))}
      </div>
    </div>
  );
}
